var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bd-qrcode","align":"center"}},[_c('div',{attrs:{"id":"qrcode"}}),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('p',[_vm._v("扫码登录萝卜丝")]),_c('el-button',{on:{"click":_vm.switchUsername}},[_vm._v("用户名登录")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }